import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api.constants';
import { ApiResponse } from '../interfaces/api-response.model';
import {
  AvailableDatesRequest,
  AvailableDatesResponse,
  BusinessAvailableDatesRequest,
} from '../interfaces/appointment-time.model';

/**
 * 選擇預約時間service
 */
@Injectable({
  providedIn: 'root',
})
export class AppointmentTimeService {
  http: HttpClient = inject(HttpClient);
  /**
   * 查詢可預約之日期
   * @param request 查詢可預約之日期請求
   */
  getAvailableDates(
    request: AvailableDatesRequest
  ): Observable<ApiResponse<AvailableDatesResponse>> {
    // TODO 改使用post請求
    // return this.axiosHttpService.post(API_ENDPOINTS.AVAILABLE_DATES, request)
    return this.http.post<ApiResponse<AvailableDatesResponse>>(
      API_ENDPOINTS.AVAILABLE_DATES,
      request
    );
  }

  /**
   * 企業查詢可預約之日期
   * @param request 企業查詢可預約之日期請求
   */
  getBusinessAvailableDates(
    request: BusinessAvailableDatesRequest
  ): Observable<ApiResponse<AvailableDatesResponse>> {
    
    return this.http.post<ApiResponse<AvailableDatesResponse>>(
      API_ENDPOINTS.BUSINESS_AVAILABLE_DATES,
      request
    );
  }
}
